import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const MAX_WIDTH = 350;
const MIN_WIDTH = 140;
const PADDING = 12;
const Z_INDEX = 2147483647;

function getPosition(x, y, preferSide, tooltipWidth, tooltipHeight) {
  const winW = window.innerWidth;
  const winH = window.innerHeight;
  let left = x, top = y;

  // Desno
  if (preferSide === 'right') {
    left = x + PADDING;
    top = y - tooltipHeight / 2;
    if (left + tooltipWidth > winW) left = x - tooltipWidth - PADDING;
    if (left < 0) left = 0;
    if (top < 0) top = 0;
    if (top + tooltipHeight > winH) top = winH - tooltipHeight;
  }
  // Lijevo
  else if (preferSide === 'left') {
    left = x - tooltipWidth - PADDING;
    top = y - tooltipHeight / 2;
    if (left < 0) left = x + PADDING;
    if (left + tooltipWidth > winW) left = winW - tooltipWidth;
    if (top < 0) top = 0;
    if (top + tooltipHeight > winH) top = winH - tooltipHeight;
  }
  // Gore
  else if (preferSide === 'top') {
    left = x - tooltipWidth / 2;
    top = y - tooltipHeight - PADDING;
    if (top < 0) top = y + PADDING;
    if (left < 0) left = 0;
    if (left + tooltipWidth > winW) left = winW - tooltipWidth;
  }
  // Dolje
  else if (preferSide === 'bottom') {
    left = x - tooltipWidth / 2;
    top = y + PADDING;
    if (top + tooltipHeight > winH) top = y - tooltipHeight - PADDING;
    if (top < 0) top = 0;
    if (left < 0) left = 0;
    if (left + tooltipWidth > winW) left = winW - tooltipWidth;
  }
  return { left, top };
}

export default function TooltipPortal({ visible, content, x, y, preferSide = 'right' }) {
  const tooltipRef = useRef(null);
  const [coords, setCoords] = useState({ left: 0, top: 0 });

  useEffect(() => {
    if (visible && tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      setCoords(getPosition(x, y, preferSide, rect.width, rect.height));
    }
  }, [visible, x, y, preferSide, content]);

  if (!visible) return null;
  return createPortal(
    <div
      ref={tooltipRef}
      style={{
        position: 'fixed',
        left: coords.left,
        top: coords.top,
        zIndex: Z_INDEX,
        background: '#222',
        color: '#fff',
        padding: '10px 18px',
        borderRadius: 8,
        fontSize: 15,
        minWidth: MIN_WIDTH,
        maxWidth: MAX_WIDTH,
        boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
        whiteSpace: 'pre-line',
        pointerEvents: 'none',
        opacity: 1,
        lineHeight: 1.4,
        transition: 'left 0.08s, top 0.08s',
        userSelect: 'text',
      }}
    >
      {content}
    </div>,
    document.body
  );
} 